import mercadoPagoLogo from "../assets/paymentGateways/mercadopago.svg";
import transbankLogo from "../assets/paymentGateways/tbk-webpay-plus.svg";
import flowLogo from "../assets/paymentGateways/flow.svg";
import khipuLogo from "../assets/paymentGateways/khipu.svg";

export interface CredentialField {
  key: string;
  label: string;
  placeholder: string;
  required: boolean;
  hint?: string;
}

/**
 * Lo PRESENTACIONAL de cada pasarela: logo, nombre, comision, textos de ayuda.
 *
 * Que soporta cada una ya no vive aca: lo publica el backend y lo trae
 * useGatewayProviders. Estaban declaradas de los dos lados y se desincronizaban
 * en cualquier deploy.
 */
export interface GatewayProviderMeta {
  key: string;
  displayName: string;
  productName: string;
  description: string;
  commission?: string;
  logo: string;
  /** @deprecated Solo para el modo manual (configuración avanzada). */
  helpSteps?: string[];
  helpUrl?: string;
  /** @deprecated Solo para el modo manual (configuración avanzada); eliminar cuando todos los gyms usen OAuth. */
  credentialFields: CredentialField[];
}

export const GATEWAY_PROVIDERS: GatewayProviderMeta[] = [
  {
    key: "mercadopago",
    displayName: "MercadoPago",
    productName: "Checkout Pro + Suscripciones",
    description:
      "Links de pago, cobros recurrentes, tarjetas, transferencia y mas",
    commission:
      "3,19% + IVA (liberación inmediata) o 2,89% + IVA (10 días). Sin costo fijo por transacción.",
    logo: mercadoPagoLogo,
    helpSteps: [
      "Ingresa a mercadopago.cl/developers y crea una aplicacion con producto Checkout Pro",
      "Copia el Access Token de produccion desde Credenciales",
      "Opcionalmente configura un Webhook Secret para verificar notificaciones",
      "En Webhooks > Configurar notificaciones, agrega la URL de webhook y selecciona el evento Pagos",
    ],
    helpUrl: "https://www.mercadopago.cl/developers/panel/app",
    credentialFields: [
      {
        key: "accessToken",
        label: "Access Token",
        placeholder: "APP_USR-...",
        required: true,
        hint: "Token de acceso de tu aplicación",
      },
      {
        key: "webhookSecret",
        label: "Webhook Secret (opcional)",
        placeholder: "Clave secreta de webhooks",
        required: false,
        hint: "Clave secreta para verificar notificaciones (recomendado)",
      },
    ],
  },
  {
    key: "flow",
    displayName: "Flow",
    productName: "Pasarela de Pagos",
    description: "Multiples medios de pago: Webpay, Servipag, MACH y mas",
    commission:
      "2,89% + IVA con abono al tercer día hábil, o 3,19% + IVA con abono al día hábil siguiente. Sin costo fijo por transacción ni costo mensual.",
    logo: flowLogo,
    helpSteps: [
      "Ingresa a flow.cl y accede a tu cuenta de comercio",
      "Ve a Integracion > Datos API y copia tu API Key y Secret Key",
      "Ambas claves son necesarias para la integracion",
    ],
    helpUrl: "https://www.flow.cl",
    credentialFields: [
      {
        key: "apiKey",
        label: "API Key",
        placeholder: "Tu API Key de Flow",
        required: true,
      },
      {
        key: "secretKey",
        label: "Secret Key",
        placeholder: "Tu Secret Key de Flow",
        required: true,
      },
    ],
  },
  {
    key: "transbank",
    displayName: "Transbank",
    productName: "Webpay Plus",
    description: "Pago con tarjetas de credito y debito via Webpay",
    logo: transbankLogo,
    credentialFields: [],
  },
  {
    key: "khipu",
    displayName: "Khipu",
    productName: "Pagos por Transferencia",
    description: "Transferencia bancaria directa desde cualquier banco chileno",
    logo: khipuLogo,
    credentialFields: [],
  },
];
